import { useState } from "react";

import { useLocalStorage } from "react-use";

import config from "@/config";
import { PageParams } from "@/shared/domain";

type PaginationProps = {
    page: PageParams;
    changePageSize: (size: number) => void;
    changePage: (page: number) => void;
};

const usePagination = (tableMode: boolean): PaginationProps => {
    const [cardPageSize, setCardPageSize] = useLocalStorage(config.KEY_CARD_LIST_SIZE, config.DEFAULT_CARD_LIST_SIZE);
    const [tablePageSize, setTablePageSize] = useLocalStorage(config.KEY_LIST_SIZE, config.DEFAULT_LIST_SIZE);
    const [pageNumber, setPageNumber] = useState(1);

    const changePageSize = (value: number) => {
        // Go back to the 1st page if page size changes
        if (tableMode) {
            setTablePageSize(value);
        } else {
            setCardPageSize(value);
        }
        setPageNumber(1);
    };
    const changePage = (value: number) => {
        setPageNumber(value);
    };

    return {
        page: { pageNumber, pageSize: tableMode ? tablePageSize : cardPageSize },
        changePage,
        changePageSize,
    };
};

export default usePagination;
